{
  "title": "Sähköpostit",
  "table": {
    "sent_at": "Lähetetty",
    "recipient": "Vastaanottaja",
    "subject": "Aihe",
    "type": "Tyyppi",
    "status": "Tila"
  },
  "status": {
    "PENDING": "Odottaa",
    "SENT": "Lähetetty",
    "FAILED": "Epäonnistui"
  },
  "types": {
    "EMAIL_VERIFICATION": "Sähköpostin vahvistus",
    "PASSWORD_RESET": "Salasanan nollaus",
    "COMPETITION_REGISTRATION_CONFIRMED": "Registrering bekräftad",
    "COMPETITION_REGISTRATION_WAITLISTED": "Registrering på reservlista",
    "COMPETITION_REGISTRATION_CANCELLED": "Registrering avbokad",
    "COMPETITION_REGISTRATION_WAITLIST_CONFIRMED": "Bekräftad från reservlistan",
    "FEEDBACK": "Användarfeedback",
    "COMPETITION_START_TIMES_PUBLISHED": "Starttider publicerade",
    "COMPETITION_PARTICIPANT_ADHOC": "Meddelande till deltagare",
    "ROUND_RESULTS_PUBLISHED": "Rundans resultat publicerade",
    "EMAIL_CHANGE_CONFIRMATION": "Bekräftelse av e-postbyte",
    "EMAIL_CHANGE_NOTICE": "Meddelande om e-postbyte"
  },
  "popover": {
    "body_label": "Viesti",
    "error_message_label": "Virheviesti"
  },
  "pagination": {
    "previous": "Edellinen",
    "next": "Seuraava",
    "page_of": "Sivu {{current}} / {{total}}"
  },
  "not_sent_yet": "(ei lähetetty)",
  "empty_state": "Ei sähköposteja",
  "refresh": "Uppdatera",
  "view_details": "Visa detaljer",
  "copy_body": "Kopiera till urklipp"
}
